import { render, staticRenderFns } from "./Disease.vue?vue&type=template&id=6840eb82&scoped=true"
import script from "./Disease.vue?vue&type=script&lang=js"
export * from "./Disease.vue?vue&type=script&lang=js"
import style0 from "./Disease.vue?vue&type=style&index=0&id=6840eb82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6840eb82",
  null
  
)

export default component.exports